var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 18.3333H18.3333",
    stroke: "#4C4C4C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.45837 18.3334L2.50004 8.30833C2.50004 7.8 2.74171 7.31671 3.14171 7.00005L8.97504 2.45837C9.57504 1.9917 10.4167 1.9917 11.025 2.45837L16.8584 6.9917C17.2667 7.30837 17.5 7.79167 17.5 8.30833V18.3334",
    stroke: "#4C4C4C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 14.1667H9.16663C8.47496 14.1667 7.91663 14.725 7.91663 15.4167V18.3333H12.0833V15.4167C12.0833 14.725 11.525 14.1667 10.8333 14.1667Z",
    stroke: "#4C4C4C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91663 11.4583H6.24996C5.79163 11.4583 5.41663 11.0833 5.41663 10.625V9.37499C5.41663 8.91666 5.79163 8.54166 6.24996 8.54166H7.91663C8.37496 8.54166 8.74996 8.91666 8.74996 9.37499V10.625C8.74996 11.0833 8.37496 11.4583 7.91663 11.4583Z",
    stroke: "#4C4C4C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 11.4583H12.0833C11.625 11.4583 11.25 11.0833 11.25 10.625V9.37499C11.25 8.91666 11.625 8.54166 12.0833 8.54166H13.75C14.2083 8.54166 14.5833 8.91666 14.5833 9.37499V10.625C14.5833 11.0833 14.2083 11.4583 13.75 11.4583Z",
    stroke: "#4C4C4C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 5.83334L15.8084 3.33334H12.1417",
    stroke: "#4C4C4C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClub);
export default __webpack_public_path__ + "static/media/club.7a0f44ebcf2d3124dc7a3a22e3276b04.svg";
export { ForwardRef as ReactComponent };